// List of admin emails. Add or remove emails to manage admin access.
export const ADMIN_EMAILS = [
  "luckyalade309@gmail.com",
  "paulinjeti@gmail.com",
  // Add more admin emails here
];
